import { createReducer, on } from '@ngrx/store';
import { defaultEntityState } from '@core/state/entities/entity';
import { IProjectSecureDetails } from '@core/state/entities/project-secure-details/project-secure-details.entity';
import { projectDetailActions } from '@core/actions/project-detail.actions';
import {
  mergeEntityState,
  removeEntities,
  removeEntitiesByFilter,
} from '@core/state/entities/entity.helpers';
import { entityKey } from '@core/state/entities/entity-name-map';

export const projectSecureDetailsEntityReducer = createReducer(
  defaultEntityState<IProjectSecureDetails>(),
  on(
    projectDetailActions.created,
    projectDetailActions.detailLoaded,
    projectDetailActions.projectForInvitationRetrieved,
    projectDetailActions.requestToJoinProjectResponseReceivedAndGranted,
    projectDetailActions.invitationsBulkRevokedSuccessfully,
    projectDetailActions.joinRequestsResponseSent,
    projectDetailActions.projectUpdated,
    projectDetailActions.projectListingUpdated,
    projectDetailActions.registered,
    projectDetailActions.agreementModeUpdated,
    (state, props) =>
      mergeEntityState(entityKey.projectSecureDetails, state, props)
  ),
  on(projectDetailActions.projectDeleted, (state, props) =>
    removeEntitiesByFilter(
      state,
      (projChild) => projChild.projectId === props.projectId
    )
  )
);
